/**
 * Call Centre Service Hooks
 * React hooks for accessing Call Centre Management services.
 */
import { useCCMS } from '../useCCMS';
/** Access all Call Centre Management services: `{ callCentreLookups, callCentreMe, callCentreAdmin }`. */
export function useCallCentreServices() {
    const { services } = useCCMS();
    if (!services?.callCentre) {
        throw new Error('Call Centre services not available. Ensure CCMSProvider is configured.');
    }
    return services.callCentre;
}
/** Lookups, ministries and public portal settings. */
export function useCallCentreLookupsService() {
    return useCallCentreServices().callCentreLookups;
}
/** Caller portal (api/callcentre/me). */
export function useCallCentreMeService() {
    return useCallCentreServices().callCentreMe;
}
/** Console admin (api/callcentre/admin) + member Journey card. */
export function useCallCentreAdminService() {
    return useCallCentreServices().callCentreAdmin;
}
//# sourceMappingURL=useCallCentreServices.js.map